<template>
  <div class="base_main bg-contain common-blue-contain">
    <div class="breadcrumb-tilte">{{ $t('DataRecord') }} > {{ $t('personAttRecord') }}</div>
    <div class="common-table-cnt">
      <div class="search search-container">
        <el-form :inline="true" :model="formAttendance" class="demo-form-inline">
          <!-- 机构列表 -->
          <el-form-item :label="$t('mechanism')">
            <el-select ref="paramOuSelect" v-model="formAttendance.ouName" style="width:auto"
              :placeholder="$t('peaseSelect')" :popper-append-to-body="false" @change="changeParamOu"
              clearable @visible-change="visibleChange">
              <el-option :value="formAttendance.ouName" style="height:auto;padding:0px">
                <el-tree ref="paramOuTree" node-key="id" default-expand-all highlight-current
                  :expand-on-click-node="false" :data="ouList" :props="defaultProps" @node-click="selectParamOu">
                </el-tree>
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 用户名 -->
          <el-form-item :label="$t('userNameH')">
            <el-input v-model="formAttendance.userName" clearable :placeholder="$t('userNameH')"></el-input>
          </el-form-item>
          <!-- 工作场所 -->
          <el-form-item :label="$t('workplace')" class="work-place">
            <el-select v-model="formAttendance.fenceId" :placeholder="$t('selectWorkplace')" clearable
              :popper-append-to-body="false">
              <el-option v-for="item in workplaceOptions" :key="item.value" :label="item.label" :value="item.value"
                style="height:auto;padding:0px">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 记录时间 -->
          <el-form-item :label="$t('attendanceDate')" class="datetime">
            <el-date-picker v-model="formAttendance.startTime" :placeholder="$t('startDate')" type="date"
              value-format="yyyy-MM-dd" popper-class="date-picker-blue-hw" :clearable="true">
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('TO')">
            <el-date-picker v-model="formAttendance.endTime" :placeholder="$t('endDate')" type="date"
              value-format="yyyy-MM-dd" popper-class="date-picker-blue-hw" :clearable="true">
            </el-date-picker>
          </el-form-item>
          <!-- 在岗时长 -->
          <el-form-item :label="$t('stayDuration')" class="datetime">
            <el-input clearable :placeholder="$t('minimumHour')" class="startWorkDuration"
              v-model="formAttendance.startWorkDuration"></el-input>
          </el-form-item>
          <el-form-item :label="$t('TO')">
            <el-input clearable :placeholder="$t('maximumHour')" class="endWorkDuration"
              v-model="formAttendance.endWorkDuration"></el-input>
          </el-form-item>

          <!-- 按钮 -->
          <el-form-item class="btns">
            <el-button type="primary" @click="getList" class="serachBtn" v-preventReClick="1000">{{ $t('query')
              }}</el-button>
            <el-button type="primary" @click="exportList" :loading="exportLoading" class="serachBtn">{{
      $t('exportButton') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- table开始 -->
      <div class="table-box">
        <el-table :data="tableData" style="width: 100%;" v-loading="loading" @sort-change="sortChange">
          <el-table-column type="index" :index="indexMethod" :label="$t('SerialNo')" align="center" width="80"
            :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ (currentPage - 1) * pageSize + scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <!-- 机构 -->
          <el-table-column prop="fullOuName" :label="$t('mechanism')" sortable="ouId"
            :sort-orders="['ascending', 'descending']">
          </el-table-column>
          <!-- 用户名 -->
          <el-table-column prop="userName" :label="$t('userNameH')" min-width="100" sortable="userId"
            :sort-orders="['ascending', 'descending']">
          </el-table-column>
          <el-table-column prop="fenceName" :label="$t('workplace')" :show-overflow-tooltip="true" sortable="fenceName"
            :sort-orders="['ascending', 'descending']">
          </el-table-column>
          <el-table-column prop="logTimestamp" :label="$t('attendanceDate')" width="155" :show-overflow-tooltip="true"
            align="center" sortable="logTimestamp" :sort-orders="['ascending', 'descending']">
          </el-table-column>
          <el-table-column prop="attendanceTime" :label="$t('attendanceDuration')" width="180"
            :show-overflow-tooltip="true" align="center" sortable="attendanceTime"
            :sort-orders="['ascending', 'descending']">
          </el-table-column>
          <el-table-column prop="clockInEarly" :label="$t('clockEarly')" width="120" align="center">
            <template slot-scope="scope">
              <span :style="getStatusStyle(scope.row.clockInEarly)">
                {{ scope.row.clockInEarly === '1' ? $t('clock') : '' }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="clockInLate" :label="$t('clockNight')" width="160" align="center">
            <template slot-scope="scope">
              <span :style="getStatusStyle(scope.row.clockInLate)">
                {{ scope.row.clockInLate === '1' ? $t('clock') : '' }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="workDuration" :label="$t('stayDurationH')" width="150" align="right"
            sortable="workDuration" :sort-orders="['ascending', 'descending']">
          </el-table-column>
          <el-table-column prop="timeInterval" :label="$t('stayPeriod')" width="220" align="center"
            sortable="timeInterval" :sort-orders="['ascending', 'descending']">
            <template slot-scope="scope">
              <div class="timeInterval">
                <div v-for="item in scope.row.timeInterval">
                  {{ item }}
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination class="pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="totalData">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getfenceName, getAttendanceDetail, getExportAttendance } from '@/api/attendance'
import { downloadBlobExcel } from '@/util/common'
import { beforeWeekDate, nowDate, getDaysDiff } from '@/util/date'
import { getOus } from '@/api/UserList'
export default {
  data() {
    return {
      // 查询表单
      formAttendance: {
        userName: '',
        ouId: null,
        startTime: beforeWeekDate(),
        endTime: nowDate(),
        startWorkDuration: null,
        endWorkDuration: null,
        fenceId: null,
        ouName: '',
      },
      // table 数据
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      totalData: 0,
      // 机构列表
      ouList: [],
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      //工作场所选项
      workplaceOptions: [],
      exportLoading: false,
      showTip: false,
      // 遮罩层
      loading: false,
    }
  },
  methods: {
    // 机构查询 滚动条置顶
    visibleChange(val) {
      this.$nextTick(() => {
        let ele = document.querySelector('.el-select-dropdown__wrap')
        ele.scrollTop = ele.scrollHeight
      })
    },
    //判断打卡、缺卡样式
    getStatusStyle(clockInTime) {
      return {
        color: clockInTime === '1' ? 'green' : 'red',
      }
    },
    // 获取组织机构
    getOusTree() {
      getOus().then(res => {
        if (res.state === 0) {
          this.ouList = res.data
        }
      })
    },
    // 选中过滤条件机构，过滤用户
    selectParamOu(data) {
      this.formAttendance.ouName = data.name
      this.formAttendance.ouId = data.id
      this.$refs.paramOuSelect.blur()
    },
    // 清空过滤条件机构，过滤用户
    changeParamOu(data) {
      if (!data) {
        this.formAttendance.ouId = null
        this.formAttendance.ouName = null
        this.$nextTick(() => {
          this.$refs.paramOuTree.setCurrentKey(null)
        })
      }
    },
    // 查询列表
    getList() {
      this.currentPage = 1
      this.handleSearch()
    },
    //导出列表
    exportList() {
      if (this.totalData >= 100000) {
        this.$message({
          type: 'warning',
          message: this.$t('maxFile'),//提示用户数据量过大，无法导出
        })
        return
      }
      this.exportLoading = true
      let params = {
        userName: this.formAttendance.userName.trim(),
        ouId: this.formAttendance.ouId,
        startTime: this.formAttendance.startTime,
        endTime: this.formAttendance.endTime,
        startWorkDuration: this.formAttendance.startWorkDuration,
        endWorkDuration: this.formAttendance.endWorkDuration,
        fenceId: this.formAttendance.fenceId,
        sortColName: this.formAttendance.sortColName,
        useAsc: this.formAttendance.useAsc,
      }
      getExportAttendance(params).then(res => {
        this.exportLoading = false
        downloadBlobExcel(res, this.$t('attendanceRecordList') + '.xls')
      })
    },
    // 点击表头排序
    sortChange({ column, prop, order }) {
      this.formAttendance.sortColName = !order ? null : column.sortable
      this.formAttendance.useAsc = order === 'descending' ? 0 : 1
      this.currentPage = 1
      this.search()
    },
    handleSearch() {
      let daysDiff = getDaysDiff(this.formAttendance.startTime, this.formAttendance.endTime)
      if (!this.showTip && daysDiff > 30) {
        this.$confirm(this.$t('searchDataTip'), {
          confirmButtonText: this.$t('determine'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning',
          closeOnClickModal: false,
        })
          .then(() => {
            this.search()
            this.showTip = true
          })
          .catch(() => {
            this.showTip = false
            return
          })
      } else {
        this.search()
      }
    },
    // 获取table数据
    search() {
      this.loading = true
      let params = {
        userName: this.formAttendance.userName.trim(),
        ouId: this.formAttendance.ouId,
        startTime: this.formAttendance.startTime,
        endTime: this.formAttendance.endTime,
        startWorkDuration: this.formAttendance.startWorkDuration,
        endWorkDuration: this.formAttendance.endWorkDuration,
        fenceId: this.formAttendance.fenceId,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        sortColName: this.formAttendance.sortColName,
        useAsc: this.formAttendance.useAsc,
      }
      getAttendanceDetail(params).then(res => {
        if (res.state === 0) {
          this.loading = false
          if (res.value.list) {
            this.tableData = res.value.list.map(i => {
              //对考勤日期和在岗时段进行处理
              i.logTimestamp = i.logTimestamp ? i.logTimestamp.split(' ')[0].trim() : ''
              i.timeInterval = i.timeInterval ? i.timeInterval.split(',') : []
              return i
            })
          } else {
            this.tableData = []
          }
          this.totalData = res.value.total
        }
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.search()
    },
    handleCurrentChange(val) {
      this.currentPage = val

      this.search()
    },
    // table 序号
    indexMethod(index) {
      return index + 1
    },
    //获取工作场所
    getWorkplace() {
      getfenceName({}).then(res => {
        if (res.state === 0) {
          //过滤出工作场所，isAttendance为true，即为考勤围栏
          this.workplaceOptions = res.data.filter(i => i.isAttendance).map(i => ({ label: i.name, value: i.id }))
        }
      })
    },
  },
  created() {
    //获取工作场所
    this.getWorkplace()
  },
  mounted() {
    this.getOusTree()
    this.search()
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl';
@import '~@/style/new-set-common.styl'
>>>.el-table
  height 645px
  min-height 460px;/* no */
  overflow: auto

>>> .el-tree-node__content
  font-weight: 400
  color: var(--new-el-select-dropdown-item)
.base_main
  .common-table-cnt
    .el-button
      margin-left 10px
    .timeInterval
      div
        float: left
        margin-right: 10px
    .startWorkDuration
      width 100px!important;/*no*/
    .endWorkDuration
      width 100px!important;/*no*/
    .pagination
      float right
      margin-top 10px
    .datetime
      margin-right 5px!important
    >>>.el-form-item__label
      padding-right 5px
      font-weight: 600
    .btns
      float: right
      margin-right: 0!important
    .work-place
      >>>.el-select-dropdown__item
        text-align: left
        margin-left 20px
    >>>.el-table
      .cell
        padding-right 6px!important
        padding-left 6px!important
    >>>.el-popper
      width 100%!important
.bg-contain .common-table-cnt /deep/ .el-table {
  height: 650px !important
}
.common-blue-contain
  .el-pagination
    margin-top 18px
</style>
